import {
  permissions,
  rolesPermission,
} from '@/shared/constant/roles-and-permissions';
import routes from '@/shared/constant/routes';
import { useAuth } from '@/shared/hooks/context/auth';
import { IAuthContext } from '@/shared/hooks/context/auth/IAuthContext';
import { useStore } from '@/shared/hooks/context/createGenericContext';

export const getPermissionFromRoute = (route: string) => {
  if (
    route.startsWith(routes.authenticate) ||
    route.startsWith(routes.logout) ||
    route.startsWith(routes.policy) ||
    route.startsWith(routes.terms) ||
    route.startsWith(routes.aydiIntelligence)
  ) {
    return { action: permissions.PUBLIC_PERMISSIONS };
  }
  if (route === routes.createCompany) {
    return { action: permissions.CAN_VIEW_CREATE_COMPANY };
  }
  if (route === routes.home) {
    return { action: permissions.CAN_VIEW_HOME_PAGE };
  }
  if (route === routes.onboarding) {
    return { action: permissions.CAN_VIEW_ONBOARDING };
  }
  if (route === routes.subscription) {
    return { action: permissions.CAN_VIEW_SUBSCRIPTION };
  }
  if (route === routes.billing) {
    return { action: permissions.CAN_VIEW_BILLING };
  }
  if (route.startsWith(routes.workforce)) {
    return { action: permissions.CAN_VIEW_WORKFORCE };
  }

  if (route.startsWith(routes.suppliers)) {
    return { action: permissions.CAN_VIEW_SUPPLIERS };
  }
  if (route.startsWith(routes.workersTimesheet)) {
    return { action: permissions.CAN_VIEW_WORKERS_TIMESHEET };
  }
  if (route.startsWith(routes.printingOrders)) {
    return { action: permissions.CAN_VIEW_PRINTING_ORDERS };
  }
  if (route.startsWith(routes.workingDay)) {
    return { action: permissions.CAN_VIEW_WORKING_DAY };
  }

  if (route.startsWith(routes.workingDayReconciliation)) {
    return { action: permissions.CAN_VIEW_WORKING_DAY_RECONCILIATION };
  }

  if (route.startsWith(routes.settlements)) {
    return { action: permissions.CAN_VIEW_SETTLEMENTS };
  }

  if (route.startsWith(routes.periodicJobs)) {
    return { action: permissions.CAN_VIEW_PERIODIC_OPERATIONS };
  }

  if (route.startsWith(routes.settings)) {
    return { action: permissions.CAN_VIEW_SETTINGS };
  }
  // TODO: who can view inactive lists

  if (
    route.startsWith(routes.warehouses) ||
    route.startsWith(routes.custody) ||
    route.startsWith(routes.returns) ||
    route === routes.warehouseManagement
  ) {
    return { action: permissions.CAN_VIEW_WAREHOUSES };
  }

  if (route.startsWith(routes.addNewStock)) {
    return { action: permissions.CAN_VIEW_ADD_NEW_STOCK };
  }

  if (route.startsWith(routes.dispatchRequests)) {
    return { action: permissions.CAN_VIEW_DISPATCH_REQUESTS };
  }
  if (route.startsWith(routes.statistics)) {
    return { action: permissions.CAN_VIEW_STATISTICS };
  }

  //   if (route.startsWith('/_error')) {
  //     return;
  //   }

  return { action: permissions.NOT_AUTHORIZED };
};

/**
 *
 * @param object of : #action : permission you need
 *                  : #role   : you need to check if this role can do this action
 *                   Note : if you not pass role it will use the current role of login user
 *
 * @returns boolean true if user role has permission to access this action
 */
export const UserHasPermission = ({
  action,
  role,
}: {
  action: string;
  role?: IAuthContext.RolesType;
}) => {
  const { user } = useAuth();
  const [store] = useStore((store) => store);
  const [isCompanyInventoryActive] = useStore(
    (store) => store?.isCompanyInventoryActive
  );
  // const showPeriodicJobs = true;
  // selectedAsset?.companyTypeId === CompanyType.COMPANY &&
  // selectedAsset?.entityTypeId === EntityType.FARM;

  if (action === permissions.PUBLIC_PERMISSIONS) {
    return true;
  }

  // if (rolesPermission?.[action]?.includes(Number(role))) {
  // if (
  //   action === permissions.CAN_VIEW_PERIODIC_OPERATIONS &&
  //   !showPeriodicJobs
  // ) {
  //   return false;
  // }
  // if company doesn't have inventory, no permission to view warehouses or dispatch requests
  if (isCompanyInventoryActive === 0 && !store?.isDemoFarm) {
    if (
      action === permissions.CAN_VIEW_WAREHOUSES ||
      action === permissions.CAN_VIEW_DISPATCH_REQUESTS
    )
      return false;
  }
  // we make parseint because user?.userGroupId some time come as string and others number ex(1 or "1")
  if (
    rolesPermission?.[action]?.includes(
      parseInt((role || user?.userGroupId || 99999999999999).toString(), 10)
    )
  ) {
    return true;
  }
  return false;
};

export const UserHasPermissionToRoute = (route: string) =>
  UserHasPermission({ action: getPermissionFromRoute(route)?.action });
